import React, { useState } from 'react';
import './CommonStyles.css';
import './AddSellStyles.css';
import './ProductSearchStyles.css';

const now = () => new Date().toLocaleString('en-US', { month: '2-digit', day: '2-digit', year: 'numeric', hour: '2-digit', minute: '2-digit', hour12: true });

const AddPurchaseReturn = ({ onBack }) => {
  const [form, setForm] = useState({
    supplier: '',
    businessLocation: '',
    referenceNo: '',
    date: now(),
    attachDocument: null,
    products: [],
    purchaseTax: '',
  });
  const [errors, setErrors] = useState({});
  const [productSearchTerm, setProductSearchTerm] = useState('');

  const handleChange = (key, value) => setForm(prev => ({ ...prev, [key]: value }));

  const totalAmount = form.products.reduce((s, p) => s + (parseFloat(p.subtotal) || 0), 0);

  const addProductRow = () => {
    if (!productSearchTerm.trim()) return;
    setForm(prev => ({
      ...prev,
      products: [...prev.products, {
        id: Date.now(),
        name: productSearchTerm.trim(),
        quantity: 1,
        unitPrice: 0,
        subtotal: 0,
      }],
    }));
    setProductSearchTerm('');
  };

  const updateProduct = (id, key, value) => {
    setForm(prev => ({
      ...prev,
      products: prev.products.map(p => {
        if (p.id !== id) return p;
        const updated = { ...p, [key]: value };
        const qty = parseFloat(updated.quantity) || 0;
        const price = parseFloat(updated.unitPrice) || 0;
        return { ...updated, subtotal: (qty * price).toFixed(2) };
      }),
    }));
  };

  const removeProduct = (id) => setForm(prev => ({ ...prev, products: prev.products.filter(p => p.id !== id) }));

  const handleSave = () => {
    const newErrors = {};
    if (!form.supplier.trim()) newErrors.supplier = 'Supplier is required';
    if (!form.businessLocation) newErrors.businessLocation = 'Business location is required';
    if (!form.date.trim()) newErrors.date = 'Date is required';
    setErrors(newErrors);
    if (Object.keys(newErrors).length > 0) return;
    alert('Save Purchase Return – API integration pending');
    if (onBack) onBack();
  };

  return (
    <div className="sell-form-container add-sell-override" style={{ overflowX: 'hidden' }}>
      <div className="page-header">
        <button
          type="button"
          onClick={onBack}
          style={{ background: 'white', border: '1px solid #e2e8f0', borderRadius: '8px', padding: '0.5rem 0.75rem', cursor: 'pointer', fontSize: '1.2rem', display: 'flex', alignItems: 'center', justifyContent: 'center', minWidth: '40px', height: '40px' }}
          title="Back to Purchases"
        >←</button>
        <h2 style={{ fontSize: '1.25rem' }}>Add Purchase Return</h2>
      </div>

      <form className="sell-form" onSubmit={(e) => { e.preventDefault(); handleSave(); }}>
        <div className="form-section-content">
          <div className="form-row" style={{ gridTemplateColumns: 'repeat(5, minmax(0, 1fr))' }}>
            <div className="form-group">
              <label>Supplier: <span style={{ color: '#ef4444' }}>*</span></label>
              <input
                type="text"
                className={`form-input ${errors.supplier ? 'error' : ''}`}
                placeholder="Please Select"
                value={form.supplier}
                onChange={(e) => handleChange('supplier', e.target.value)}
              />
              {errors.supplier && <span className="error-text">{errors.supplier}</span>}
            </div>

            <div className="form-group">
              <label>Business Location: <span style={{ color: '#ef4444' }}>*</span></label>
              <select
                className={`form-select ${errors.businessLocation ? 'error' : ''}`}
                value={form.businessLocation}
                onChange={(e) => handleChange('businessLocation', e.target.value)}
              >
                <option value="">Please Select</option>
                <option value="1">Main Location</option>
              </select>
              {errors.businessLocation && <span className="error-text">{errors.businessLocation}</span>}
            </div>

            <div className="form-group">
              <label>Reference No:</label>
              <input
                type="text"
                className="form-input"
                value={form.referenceNo}
                onChange={(e) => handleChange('referenceNo', e.target.value)}
              />
            </div>

            <div className="form-group">
              <label>Date: <span style={{ color: '#ef4444' }}>*</span></label>
              <input
                type="text"
                className={`form-input ${errors.date ? 'error' : ''}`}
                value={form.date}
                onChange={(e) => handleChange('date', e.target.value)}
              />
              {errors.date && <span className="error-text">{errors.date}</span>}
            </div>
            <div className="form-group" style={{ minWidth: 0, overflow: 'hidden' }}>
              <label>Attach Document:</label>
              <input
                type="file"
                className="form-input"
                accept=".pdf,.csv,.zip,.doc,.docx,.jpeg,.jpg,.png"
                onChange={(e) => handleChange('attachDocument', e.target.files[0] || null)}
              />
              <span className="file-hint">Max File size: 5MB &nbsp;|&nbsp; .pdf .csv .zip .doc .docx .jpeg .jpg .png</span>
            </div>
          </div>
        </div>

        <hr className="section-divider" />

        {/* Products Section */}
        <div className="form-section-content">
          <div className="form-row">
            <div className="form-group full-width">
              <label>Search Products:</label>
              <div style={{ display: 'flex', gap: '0.5rem' }}>
                <input
                  type="text"
                  className="form-input"
                  placeholder="Search Products"
                  value={productSearchTerm}
                  onChange={(e) => setProductSearchTerm(e.target.value)}
                  onKeyDown={(e) => { if (e.key === 'Enter') { e.preventDefault(); addProductRow(); } }}
                />
                <button
                  type="button"
                  onClick={addProductRow}
                  style={{ padding: '0 1rem', background: '#3b82f6', color: 'white', border: 'none', borderRadius: '6px', cursor: 'pointer', whiteSpace: 'nowrap', fontWeight: '500' }}
                >Add</button>
              </div>
            </div>
          </div>

          <div className="product-table" style={{ overflowX: 'auto' }}>
            <table style={{ minWidth: '700px', width: '100%' }}>
              <thead>
                <tr>
                  <th style={{ width: '4%' }}>#</th>
                  <th>Product</th>
                  <th style={{ width: '12%' }}>Quantity</th>
                  <th style={{ width: '15%' }}>Unit Price</th>
                  <th style={{ width: '15%' }}>Subtotal</th>
                  <th style={{ width: '4%' }}></th>
                </tr>
              </thead>
              <tbody>
                {form.products.length === 0 ? (
                  <tr><td colSpan={6} className="no-products">No products added</td></tr>
                ) : (
                  form.products.map((p, idx) => (
                    <tr key={p.id}>
                      <td style={{ textAlign: 'center', color: '#64748b', fontSize: '0.8rem' }}>{idx + 1}</td>
                      <td style={{ fontWeight: '500', fontSize: '0.875rem' }}>{p.name}</td>
                      <td>
                        <div className="quantity-input-group">
                          <button type="button" className="qty-btn minus" onClick={() => updateProduct(p.id, 'quantity', Math.max(1, (parseInt(p.quantity) || 1) - 1))}>-</button>
                          <input type="number" className="quantity-input-centered" value={p.quantity} min="1" onChange={(e) => updateProduct(p.id, 'quantity', e.target.value)} />
                          <button type="button" className="qty-btn plus" onClick={() => updateProduct(p.id, 'quantity', (parseInt(p.quantity) || 1) + 1)}>+</button>
                        </div>
                      </td>
                      <td><input type="number" className="form-input unit-price-input" value={p.unitPrice} min="0" step="0.01" onChange={(e) => updateProduct(p.id, 'unitPrice', e.target.value)} /></td>
                      <td style={{ textAlign: 'right', paddingRight: '0.5rem', fontWeight: '600' }}>{parseFloat(p.subtotal || 0).toFixed(2)}</td>
                      <td><button type="button" className="remove-product-btn" onClick={() => removeProduct(p.id)}>✕</button></td>
                    </tr>
                  ))
                )}
              </tbody>
            </table>
          </div>

          <div style={{ display: 'flex', justifyContent: 'flex-end', gap: '2rem', padding: '0.75rem 0.5rem', fontSize: '0.9rem', color: '#475569' }}>
            <div>
              <label style={{ fontWeight: '500', marginRight: '0.5rem' }}>Purchase Tax:</label>
              <select className="form-select" style={{ width: 'auto', display: 'inline-block' }} value={form.purchaseTax} onChange={(e) => handleChange('purchaseTax', e.target.value)}>
                <option value="">None</option>
                <option value="gst5">GST 5%</option>
                <option value="gst10">GST 10%</option>
                <option value="vat15">VAT 15%</option>
              </select>
            </div>
            <div style={{ fontWeight: '700', fontSize: '1rem', color: '#1e293b' }}>
              Total Amount: {totalAmount.toFixed(2)}
            </div>
          </div>
        </div>

        <div className="form-section-content action-buttons-section">
          <div className="action-buttons">
            <button type="submit" className="save-btn">💾 Save</button>
            <button type="button" className="save-print-btn" onClick={handleSave}>🖨️ Save & Print</button>
          </div>
        </div>
      </form>
    </div>
  );
};

export default AddPurchaseReturn;
